import Vue from "vue";

const PLAN_FREE = {
    id: 1,
    slug: 'free',
    name: 'Free',
    price: 0
}

const PLAN_PRO = {
    id: 2,
    slug: 'pro',
    name: 'fylm.ai Pro',
    price: 19
}

const PLAN_PRO_YEARLY = {
    id: 3,
    slug: 'pro-yearly',
    name: 'fylm.ai Pro Yearly',
    price: 180
}

const PLAN_TEAM = {
    id: 4,
    slug: 'team',
    name: 'fylm.ai Team',
    price: 49
}

const PLAN_TEAM_YEARLY = {
    id: 5,
    slug: 'team-yearly',
    name: 'fylm.ai Team Yearly',
    price: 360
}

const PLAN_LITE_FREE = {
    id: 7,
    slug: 'fylm-ai-lite-free',
    name: 'Free',
    price: 0
}

const PLAN_LITE = {
    id: 8,
    slug: 'fylm-ai-lite',
    name: 'fylm.ai Lite',
    price: 84,
}

const getDefaultState = () => {
    return {
        plans: [],
        selectedPlan: null,
        PLAN_FREE,
        PLAN_PRO,
        PLAN_PRO_YEARLY,
        PLAN_TEAM,
        PLAN_TEAM_YEARLY,
        PLAN_LITE_FREE,
        PLAN_LITE,
        selectablePlans: [
            PLAN_LITE_FREE,
            PLAN_LITE
        ]
    };
};

const Plans = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        SET_PLANS: async (state, plans) => {
            state.plans = plans;
        },
        RESET_STATE: state => {
            Object.assign(state, getDefaultState());
        },
        SET_SELECTED_PLAN: (state, payload) => {
            state.selectedPlan = payload;
        },
    },
    actions: {
        fetchPlans: ({commit}) => {
            return Vue.prototype.$apiService
                .get("plans")
                .then(response => {
                    let plans = response.data.filter(plan => plan.slug !== "enterprise"); // getting rid of enterprise plan
                    commit("SET_PLANS", plans);
                })
                .catch(err => console.log(err.response));
        },
        resetState: ({commit}) => {
            commit("RESET_STATE");
        },
        setSelectedPlan: ({commit}, payload) => {
            commit("SET_SELECTED_PLAN", payload);
        },
    },
    getters: {
        getPlan: state => id => {
            return state.plans.find(plan => plan.id == id);
        },
        getPlanName: (state, getter) => id => {
            if (state.plans) return getter.getPlan(id).name;
        },
        planData: (state, getter) => id => {
            let plan = getter.getPlan(id);
            if (plan) return JSON.parse(plan.data);
            else return null;
        },
        planPrice: (state, getter) => id => {
            let plan = getter.getPlan(id);
            if (plan) return plan.price;
        },
        selectedPlan: (state, getter) => {
            return getter.getPlan(state.selectedPlan);
        },
        getSelectablePlans: state => {
            return state.plans.filter(plan => [
                // PLAN_FREE.slug,
                PLAN_PRO_YEARLY.slug,
                PLAN_TEAM_YEARLY.slug,
                PLAN_LITE.slug
            ].includes(plan.slug))
        },
        getSelectablePlansWhenRegistering: state => {
            return state.plans.filter(plan => [
                PLAN_LITE_FREE.slug,
                PLAN_LITE.slug,
            ].includes(plan.slug))
        }
    },
};

export default Plans;
